import * as React from 'react';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import styled from 'styled-components';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { ModalWindow, Notification } from '../../components';
import { PDFViewer, IPDFPreviewProps, StyledPdfWrapper } from './PDFPreview';
import { printPlugin } from '@react-pdf-viewer/print';
import { useHasPermissions } from '../../../components/accessControl/hooks/useHasPermissions';
import { ePermissions } from '../../../types/administration/userAdministration/ePermissions';
import { Show } from '../../../components/shared/Show';

interface ICheckPDFPreviewProps extends IPDFPreviewProps {
    onSend: () => void;
    onPrint: () => void;
    file: Uint8Array;
}

export const CheckPDFPreview: React.FC<ICheckPDFPreviewProps> = ({ file, onClose, onSend, onPrint, httpHeader }) => {
    const printPluginInstance = printPlugin();
    const { print } = printPluginInstance;
    const hasOnlyPrintCheckPermissions = useHasPermissions([ePermissions.EscrowCheckIssuanceDateEdit]);

    return <ModalWindow width={'80%'} onClose={onClose} mode={'transition'}>
        <div className="mb-1">
            <Notification type={`warning`} message={"Confirm that your check has printed correctly before closing this modal."} />
        </div>
        <StyledCheckPdfWrapper>
            <PDFViewer
                file={file}
                httpHeader={httpHeader}
                onDocumentLoad={print}
                plugins={[printPluginInstance]}
            />
        </StyledCheckPdfWrapper>
        <div className={'text-end'}>
            <ButtonTW className={'m-4'} secondary ghost onClick={onClose}>Cancel</ButtonTW>
            <Show when={hasOnlyPrintCheckPermissions}>
              <ButtonTW secondary onClick={onPrint} className={'mr-4'}>Confirm Print</ButtonTW>
            </Show>
            <ButtonTW onClick={onSend}>Confirm Print and Send</ButtonTW>
        </div>
    </ModalWindow>
}

const StyledCheckPdfWrapper = styled(StyledPdfWrapper)`
  height: 66vh;
`;
